import React, { Component } from 'react'
import PropTypes from 'prop-types'

import ChangeOrderView from './ChangeOrderView'

const propTypes = {
  estimateItems: PropTypes.array,
  loadingEstimateItems: PropTypes.bool.isRequired
}
class ChangeOrderEditor extends Component {
  render() {
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <ChangeOrderView {...this.props} />
          </div>
        </div>
      </div>
    )
  }
}

ChangeOrderEditor.propTypes = propTypes
export default ChangeOrderEditor



// WEBPACK FOOTER //
// ./src/components/ChangeOrderEditor.js